/* eslint-disable import/prefer-default-export */
export const BACKEND_API = process.env.REACT_APP_BACKEND_API;
